/**
 * Class DataTransformers
 *
 * this is a one-stop shop for modelling the data
 * each is a receiver of raw load data, JSON-ifies it,
 * then applies that data to a value object
 * that is then returned as a result of the function
 */
define('GameDayCore/GDModel/transform/DataTransformers',['require','exports','module','jquery','../storage/ResponseCache','data-transformers/xml-to-json','data-transformers/json','../ValueObjects/Game/GameFile','../ValueObjects/Resources/StaticResources','../ValueObjects/Scoreboard/Miniscoreboard/GameMiniscoreboard','../ValueObjects/Plays/Plays','../ValueObjects/Boxscore/Boxscore','../ValueObjects/Players/Lineup','../ValueObjects/Linescore/Linescore','../ValueObjects/Bench/BenchFile','../ValueObjects/Scoreboard/Innings','../ValueObjects/Scoreboard/AllInnings','../ValueObjects/Plays/ScoringPlays','../ValueObjects/Players/PlayersFile','../ValueObjects/Players/PlayerCard','../ValueObjects/HotColdZone/HotColdZones','../ValueObjects/Hits/HitsFile','../ValueObjects/Gamecenter/Gamecenter','../ValueObjects/RealTimeHighlights/Highlights','../ValueObjects/Gamecenter/TeamVsPitcher5Y','../ValueObjects/Gamecenter/TeamLineupHittingStats','../ValueObjects/Gamecenter/TicketLinks','../ValueObjects/Gamecenter/WrapupArticleList','../ValueObjects/Gamecenter/WrapupVideoList','../ValueObjects/Resources/MidInningGame','../ValueObjects/Gamecenter/StatcastBatterAverages','../../GDUtil/window/Logg'],function(require, exports, module) {
	var $ = require("jquery"),
        ResponseCache = require("../storage/ResponseCache"),
        XMLtoJSON = require("data-transformers/xml-to-json"),
        JsonTransformer = require("data-transformers/json"),
        // NOTE: there was a regEx saftey in gdHTML5 for xml en español.
        // the Value Object definitions
        GameFile = require("../ValueObjects/Game/GameFile"),
        StaticResources = require("../ValueObjects/Resources/StaticResources"),
        GameMiniscoreboard = require("../ValueObjects/Scoreboard/Miniscoreboard/GameMiniscoreboard"),
        Plays = require("../ValueObjects/Plays/Plays"),
        Boxscore = require("../ValueObjects/Boxscore/Boxscore"),
        Lineup = require("../ValueObjects/Players/Lineup"),
        Linescore = require("../ValueObjects/Linescore/Linescore"),
        BenchFile = require("../ValueObjects/Bench/BenchFile"),
        Innings = require("../ValueObjects/Scoreboard/Innings"),
        AllInnings = require("../ValueObjects/Scoreboard/AllInnings"),
        ScoringPlays = require("../ValueObjects/Plays/ScoringPlays"),
        PlayersFile = require("../ValueObjects/Players/PlayersFile"),
        PlayerCard = require("../ValueObjects/Players/PlayerCard"),
        HotColdZones = require("../ValueObjects/HotColdZone/HotColdZones"),
        HitsFile = require("../ValueObjects/Hits/HitsFile"),
        Gamecenter = require("../ValueObjects/Gamecenter/Gamecenter"),
        Highlights = require("../ValueObjects/RealTimeHighlights/Highlights"),
        TeamVsPitcher5Y = require("../ValueObjects/Gamecenter/TeamVsPitcher5Y"),
        TeamLineupHittingStats = require("../ValueObjects/Gamecenter/TeamLineupHittingStats"),
        TicketLinks = require("../ValueObjects/Gamecenter/TicketLinks"),
        WrapupArticleList = require("../ValueObjects/Gamecenter/WrapupArticleList"),
        WrapupVideoList = require("../ValueObjects/Gamecenter/WrapupVideoList"),
        MidInningGames = require("../ValueObjects/Resources/MidInningGame"),
        StatcastBatterAverages = require('../ValueObjects/Gamecenter/StatcastBatterAverages'),
        logg = require("../../GDUtil/window/Logg");

	return {
		GumboJsonParser: function (data, daatasource, params) {
			var gumboJSON = JsonTransformer(data);
			return gumboJSON;
		},

		GameXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new GameFile(json.game);
		},

		DisplayConfigXMLToModelTransformer: function (data, datasource, params) {
			try {
				//
				return { };
			} catch (err) {
				logg.log("ERROR! transforming display config file..." + err);
			}
		},

		GdConfigToModelTransformer: function (data, datasource, params) {
			try {
				//
				return { };
			} catch (err) {
				logg.log("ERROR! transforming gameday config file..." + err);
			}
		},

		SkinConfigToModelTransformer: function (data, datasource, params) {
			try {
				//
				return { };
			} catch (err) {
				logg.log("ERROR! transforming skin config file..." + err);
			}
		},

		StaticResourcesJSONToModelTransformer: function (data, datasource, params) {
			var json = JsonTransformer(data,datasource,params);
			return new StaticResources(json.staticresources);
		},

		GameMiniscoreboardXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

			return new GameMiniscoreboard(json.game);
		},

		PlaysXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

			return new Plays(json.game);
		},
		
		BoxscoreXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

			return new Boxscore(json.boxscore);
		},

		LinesupJSONToModelTransformer: function (data, datasource, params) {
			var json = JsonTransformer(data);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);
			return new Lineup(json);
		},

		LinescoreXMLToModelTransformer: function (data, datasource, params) {
			
            var json = XMLtoJSON(data, datasource, params);

			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

			return new Linescore(json.game);
		},

		BenchFileXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

			return new BenchFile(json.bench);
		},

		InningXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params),
				inning=new Innings(json.inning);
			return new Innings(json.inning);
		},

		AllInningsXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new AllInnings(json.inning);
		},

		TeamVsPitcher5YXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new TeamVsPitcher5Y(json.team_bvp_5y);
		},

		TeamLineupHittingStatsXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new TeamLineupHittingStats(json);
		},

		TicketsXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new TicketLinks(json);
		},

		ScoringPlaysXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new ScoringPlays(json.scores);
		},

		PlayersXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new PlayersFile(json.game);
		},

		PlayerCardXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new PlayerCard(json.Player);
		},

		HotColdZoneXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new HotColdZones(json.std, params);
		},

		HitChartXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new HitsFile(json.hitchart);
		},

        JingleJsonValueParser: function (data, datasource, params) {
            var json = new $.parseJSON(data.text, datasource, params);
            return json;
        },

		GamecenterXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return new Gamecenter(json.game, params);
		},

		HighlightsXMLToModelTransformer: function (data, datasource, params) {
            var json = XMLtoJSON(data, datasource, params);
            ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);

            return new Highlights(json.highlights);
		},

		DateTimeJSONToModelTransformer: function (data, datasource, params) {
			//parse the json and store the skin object array on the DisplayConfigModel
			var json = new $.parseJSON(data, datasource, params);
			return new DateTime(json);
		},

        MidInningGameXmlToModelTransformer: function (data, datasource, params) {
            var json = XMLtoJSON(data);
            return new MidInningGames(json.gamedayGames);
        },

		MoundballXMLToModelTransformer: function (data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
			return json.moundballs.moundball;
		},

		WrapupArticleListTransformer: function(data, datasource, params) {
			var json = JsonTransformer(data);
			ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);
			return new WrapupArticleList(json);
		},

		WrapupVideoListTransformer: function(data, datasource, params) {
			var json = XMLtoJSON(data, datasource, params);
            ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);
			return new WrapupVideoList(json.data);
		},

		StatcastBatterAveragesTransformer: function(data, datasource, params) {
			var json = new $.parseJSON(data.text, datasource, params);
            ResponseCache.verifyChangeAndStore(datasource.dataSourceName, params.responseText);
			return new StatcastBatterAverages(json);
		}

	}
});
